import { fetchGenerateProxies } from '@fd/common/api/fetchGenerateProxies';
import useProxiesInPool from '@/hooks/queries/useProxiesInPool';
import { Minus, Plus } from 'lucide-react';
import { useState } from 'react';
import Flex from '../ui/Flex';
import { useToast } from '@/hooks/useToast';

export default function GenerateProxies({ poolId }: { poolId: number }) {
  const [proxyAmount, setProxyAmount] = useState(20);
  const { mutate: mutateProxies } = useProxiesInPool(poolId);
  const { toast } = useToast();
  return (
    <Flex.Row className="gap-2 w-full sm:w-fit">
      <div className="flex border border-gray-200 rounded-md max-w-48">
        <button
          className="p-2.5"
          onClick={() => {
            setProxyAmount(Math.max(0, proxyAmount - 1));
          }}
        >
          <Minus className="h-5 w-5" />
        </button>
        <div className="flex-1 relative">
          <input
            type="text"
            inputMode="numeric"
            value={proxyAmount}
            onChange={(e) => {
              const value = e.target.value;
              if (value === '' || !isNaN(Number(value))) {
                setProxyAmount(Number(value));
              }
            }}
            className="w-full h-full text-center py-2 focus:outline-none focus:ring-1 focus:ring-proxy-primary"
            aria-label="Proxies quantity"
          />
        </div>
        <button
          className="p-2.5"
          onClick={() => {
            setProxyAmount(proxyAmount + 1);
          }}
        >
          <Plus className="h-5 w-5" />
        </button>
      </div>
      <button
        className="border border-primary-purple text-primary-purple rounded-lg px-3 text-sm w-full sm:w-fit"
        onClick={async () => {
          await fetchGenerateProxies(poolId, proxyAmount);
          await mutateProxies();
          toast({
            title: 'Proxies added',
            description: `${proxyAmount} proxies added to the pool`,
          });
        }}
      >
        Add
      </button>
    </Flex.Row>
  );
}
